module.exports = __webpack_public_path__ + "static/media/Avatar_5.21ee734c.svg";